export default "a3a2c51e7e7ad8ec.svg"